export const SET_APP_LANG = 'SET_APP_LANG'
export const GET_CATEGORY_ENUMS = 'GET_CATEGORY_ENUMS'
export const GET_SUB_CATEGORY_ENUMS = 'GET_SUB_CATEGORY_ENUMS'
export const GET_COLOR_ENUMS = 'GET_COLOR_ENUMS'
export const GET_YEAR_ENUMS = 'GET_YEAR_ENUMS'
export const GET_BRAND_ENUMS = 'GET_BRAND_ENUMS'
export const GET_MODEL_ENUMS = 'GET_MODEL_ENUMS'
export const GET_GARAGE_ENUMS = 'GET_GARAGE_ENUMS'
export const GET_BRANCH_ENUMS = 'GET_BRANCH_ENUMS'
export const GET_PROVIDER_ENUMS = 'GET_PROVIDER_ENUMS'
export const GET_FEATURES_ENUMS = 'GET_FEATURES_ENUMS'
export const GET_LICENSE_TYPE_ENUMS = 'GET_LICENSE_TYPE_ENUMS'
export const GET_LANGUAGE_ENUMS = 'GET_LANGUAGE_ENUMS'
export const GET_NATIONALITY_ENUMS = 'GET_NATIONALITY_ENUMS'
export const GET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS = 'GET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS'
export const GET_DRIVER_LIST_ENUMS = 'GET_DRIVER_LIST_ENUMS'
export const GET_ADMINS_ENUMS = 'GET_ADMINS_ENUMS'
export const GET_ROLES_ENUMS = 'GET_ROLES_ENUMS'
export const GET_ACTIVE_ROLES_ENUMS = 'GET_ACTIVE_ROLES_ENUMS'
export const GET_SERVICE_TYPE_ENUMS = 'GET_SERVICE_TYPE_ENUMS'
export const GET_CLIENT_ENUMS = 'GET_CLIENT_ENUMS'
export const GET_CITY_ENUMS = 'GET_CITY_ENUMS'
export const GET_DAMAGE_LEVEL_ENUMS = 'GET_DAMAGE_LEVEL_ENUMS'
export const GET_DAMAGE_AREA_ENUMS = 'GET_DAMAGE_AREA_ENUMS'
export const GET_BODY_DAMAGE_AREA_ENUMS = 'GET_BODY_DAMAGE_AREA_ENUMS'
export const GET_USER_INFO = 'GET_USER_INFO'
export const GET_CLIENT_INFO = 'GET_CLIENT_INFO'
export const GET_COMPANIES_ENUMS = 'GET_COMPANIES_ENUMS'
export const GET_INSURANCE_COMPANY_ENUMS = 'GET_INSURANCE_COMPANY_ENUMS'
export const GET_REGIONS_ENUMS = 'GET_REGIONS_ENUMS'
export const GET_PROVINCES_ENUMS = 'GET_PROVINCES_ENUMS'
export const GET_ZONE_ENUMS = 'GET_ZONE_ENUMS'
export const GET_POS_ENUMS = 'GET_POS_ENUMS'
export const GET_MOBILE_ENUMS = 'GET_MOBILE_ENUMS'
export const GET_SERVICES_ENUMS = 'GET_SERVICES_ENUMS'
export const GET_DRIVER_AVAILABILITY = 'GET_DRIVER_AVAILABILITY'
export const GET_VEHICLE_AVAILABILITY = 'GET_VEHICLE_AVAILABILITY'
export const GET_PROMO_CODE_ENUMS = 'GET_PROMO_CODE_ENUMS'
export const GET_LTA_LIST_ENUMS = 'GET_LTA_LIST_ENUMS'
export const GET_CLIENT_TYPE_ENUMS = 'GET_CLIENT_TYPE_ENUMS'
export const GET_ACCOUNT_ENUMS = 'GET_ACCOUNT_ENUMS'
export const GET_PROFORMA_INVOICE_ENUMS = 'GET_PROFORMA_INVOICE_ENUMS'
export const GET_JV_ENUMS = 'GET_JV_ENUMS'
export const GET_RESERVATION_LIST_ENUMS = 'GET_RESERVATION_LIST_ENUMS'
export const GET_REMOTE_FINANCE_ACCOUNT_ENUMS = 'GET_REMOTE_FINANCE_ACCOUNT_ENUMS'
export const GET_TAX_TYPE_ENUMS = 'GET_TAX_TYPE_ENUMS'
export const GET_TAX_TYPE_ZOHO_ENUMS = 'GET_TAX_TYPE_ZOHO_ENUMS'
export const GET_OPERATOR = 'GET_OPERATOR'
export const GET_TRAINING_TYPES_ENUMS = 'GET_TRAINING_TYPES_ENUMS'
export const GET_TAX_TYPE_ODOO_ENUMS = 'GET_TAX_TYPE_ODOO_ENUMS'
export const GET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS = 'GET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS'
export const GET_PRODUCT_ENUMS = 'GET_PRODUCT_ENUMS'
export const GET_PRICING_LISTS_ENUMS = 'GET_PRICING_LISTS_ENUMS'
export const GET_TGA_TYPES_ENUMS = 'GET_TGA_TYPES_ENUMS'
export const GET_RELIGION_ENUMS = 'GET_RELIGION_ENUMS'
export const GET_CLIENT_GRADE_ENUMS = 'GET_CLIENT_GRADE_ENUMS'
export const GET_RESERVATION_CATEGORY_ENUMS = 'GET_RESERVATION_CATEGORY_ENUMS'
export const GET_SERVICE_CATEGORY_ENUMS = 'GET_SERVICE_CATEGORY_ENUMS'
export const GET_CONTRACT_TYPE_ENUMS = 'GET_CONTRACT_TYPE_ENUMS'
export const GET_DRIVER_USERNAME_ENUMS = 'GET_DRIVER_USERNAME_ENUMS'
export const GET_CLIENT_USERNAME_ENUMS = 'GET_CLIENT_USERNAME_ENUMS'
export const GET_RESOURCE_REQUEST_USERNAME_ENUMS = 'GET_RESOURCE_REQUEST_USERNAME_ENUMS'
export const GET_USER_ENUMS = 'GET_USER_ENUMS'
export const GET_RESERVATION_FILE = 'GET_RESERVATION_FILE'
export const GET_TRIPS_FILE = 'GET_TRIPS_FILE'
export const SET_MISSING_REQUEST_PAYLOAD_IN_STORE = 'SET_MISSING_REQUEST_PAYLOAD_IN_STORE'
export const GET_VEHICLE_TYPE_ENUMS = 'GET_VEHICLE_TYPE_ENUMS'
export const GET_BLANKET_ORDER_ENUMS = 'GET_BLANKET_ORDER_ENUMS'
export const GET_KPI_REASON_ENUMS = 'GET_KPI_REASON_ENUMS'
export const GET_CLIENT_CITY_ENUMS = 'GET_CLIENT_CITY_ENUMS'
export const GET_CLIENT_COUNTRY_ENUMS = 'GET_CLIENT_COUNTRY_ENUMS'
export const GET_MODEL_INCLUDED_ENUMS = 'GET_MODEL_INCLUDED_ENUMS'
export const SHOW_TOASTER_POP = 'SHOW_TOASTER_POP'
export const GET_AVAILABLE_RESERVATION_LIST_ENUMS = 'GET_AVAILABLE_RESERVATION_LIST_ENUMS'
export const GET_CHANGE_PASSWORD_TOKEN = 'GET_CHANGE_PASSWORD_TOKEN'
export const GET_SHIFT_TYPE_ENUMS = 'GET_SHIFT_TYPE_ENUMS'
export const GET_CONTRACT_ID_ENUMS = 'GET_CONTRACT_ID_ENUMS'
export const GET_CONTRACT_ID_CLIENT_ENUMS = 'GET_CONTRACT_ID_CLIENT_ENUMS'
export const GET_DRIVER_EMPLOYEE_ID_ENUMS = 'GET_DRIVER_EMPLOYEE_ID_ENUMS'
export const GET_PAYMENT_TYPES_ENUMS = 'GET_PAYMENT_TYPES_ENUMS'
export const GET_CLIENT_CONTACT_PERSON_ENUMS = 'GET_CLIENT_CONTACT_PERSON_ENUMS'
export const GET_ENTITY_ENUMS = 'GET_ENTITY_ENUMS'
export const GET_USERNAME_ENUMS = 'GET_USERNAME_ENUMS'
export const GET_ADMIN_CONFIGURATION_ENUMS = 'GET_ADMIN_CONFIGURATION_ENUMS'
export const GET_DRIVER_ALLOWANCE_FILE = 'GET_DRIVER_ALLOWANCE_FILE'
export const GET_DRIVER_EMP_ID_ENUMS = 'GET_DRIVER_EMP_ID_ENUMS'
export const GET_PRICING_LIST_FILE = 'GET_PRICING_LIST_FILE'
export const GET_ROUTES_LIST_ENUMS = 'GET_ROUTES_LIST_ENUMS'
export const GET_TRIPS_CONTRACT_FILE = 'GET_TRIPS_CONTRACT_FILE'
export const GET_WORKFLOW_ENUMS = 'GET_WORKFLOW_ENUMS'
export const GET_PROFORMA_INVOICE_NUMBER_ENUMS = 'GET_PROFORMA_INVOICE_NUMBER_ENUMS'
export const GET_USER_NAME_ENUMS = 'GET_USER_NAME_ENUMS'
export const GET_BLANKET_ORDER_ORDER_CODE_ENUMS = 'GET_BLANKET_ORDER_ORDER_CODE_ENUMS'
export const GET_SERVICE_POINT_ENUMS = 'GET_SERVICE_POINT_ENUMS'
export const GET_WATER_SOURCE_ENUMS = 'GET_WATER_SOURCE_ENUMS'
export const GET_BRANCH_GARAGE_ENUMS = 'GET_BRANCH_GARAGE_ENUMS'
export const DELETE_USER = 'DELETE_USER'
export const GET_BRANCH_WATERSOURCE_ENUMS = 'GET_BRANCH_WATERSOURCE_ENUMS'
export const GET_Certificate_of_Completion_ENUMS = 'GET_Certificate_of_Completion_ENUMS'
export const GET_TRIP_COMPLETE_NOTE = 'GET_TRIP_COMPLETE_NOTE'
export const GET_TRIP_RATING_ENUMS = ' GET_TRIP_RATING_ENUMS'
export const GET_DRIVER_RATINGS = 'GET_DRIVER_RATINGS'
export const GET_DRIVER_RATING_SUMMARY = 'GET_DRIVER_RATING_SUMMARY'
export const GET_Certificate_of_Completion_BY_ID = 'GET_Certificate_of_Completion_BY_ID'
export const GET_Certificate_Contract_Details_ENUMS = 'GET_Certificate_Contract_Details_ENUMS'
export const Create_Certificate_Of_Completion_ENUMS = 'Create_Certificate_Of_Completion_ENUMS'
export const GET_Certificate_Of_Completion_PROFILE_ENUMS =
  'GET_Certificate_Of_Completion_PROFILE_ENUMS'
export const GET_Contractors_Contracts = 'GET_Contractors_Contracts'
export const GET_Tank_ENUMS = 'GET_Tank_ENUMS'
export const GET_Certificate_Logs = 'GET_Certificate_Logs'
export const GET_Tanker_Types = 'GET_Tanker_Types'
export const GET_AVAILABLE_ZONE_ENUMS = "GET_AVAILABLE_ZONE_ENUMS";
